<app-split-container>
  <div slot="left">
    <app-login-dialog-image
      *ngIf="!customMessage()"
      [title]="'login.login.infoTitle' | translate"
      [subtitle]="'login.login.infoSubtitle' | translate"
    >
      <app-login-image></app-login-image>
    </app-login-dialog-image>

    <div *ngIf="customMessage()" class="custom-message" [innerHTML]="customMessage() | safe"></div>
  </div>

  <div slot="right">
    <opac-button class="submit-button" (click)="login()">
      {{ 'login.submit' | translate }}
    </opac-button>

    <opac-divider>{{ 'common.or' | translate }}</opac-divider>

    <div class="links-container">
      <a
        href="#"
        (click)="loadLogin($event)"
        (keydown.enter)="loadLogin($event)"
        (keydown.space)="loadLogin($event)"
      >
        {{ 'login.login.guestLogin' | translate }}
      </a>
    </div>
  </div>
</app-split-container>
